import type { RouteRecordRaw } from 'vue-router';

// Reading is in the AUTHORIZED floor, stakeholders included: a program page is
// what a customer opens to see which step is next and what it waits on. Which
// programs they see is the organization perimeter's job, enforced by the API.
export const programsRoute: RouteRecordRaw = {
  path: '/programs',
  name: 'Programs',
  component: () => import('./pages/ProgramsPage.vue'),
  meta: {
    title: 'Programs',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:programs:list'),
  },
};

export const programRoute: RouteRecordRaw = {
  path: '/programs/:id',
  name: 'Program',
  component: () => import('./pages/ProgramPage.vue'),
  meta: {
    title: 'Program',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:programs:get'),
  },
};
